import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-YO-logo_svg__Untitled-Page_201",
  "data-name": "Untitled-Page%201",
  viewBox: "0 0 205.35 51.27"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-YO-logo_svg__cls-1{fill:#e71b02;stroke:#e71b02;stroke-width:2px}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("g", {
      id: "svg-YO-logo_svg__Calque_201",
      "data-name": "Calque%201"
    }, [
      _createElementVNode("path", {
        d: "M170.4 41.99c-20.2-7.7-40.4-4.5-60.6-1-18.8 3.2-37.5 6.6-56.4 9-7.1.9-14.6-.5-21.8-1.7-3.4-.6-6.4-3.1-9.4-5.5 14.6 6.9 28 2.6 41.7-2.8 16.3-6.5 32.5-13.3 49.2-18.2 23.5-7 41.6 4.2 57.3 20.2ZM44.8 12.09c53.9 1.6 107.3-2.5 160.3-11.1-52.8 13.3-106.3 16.3-160.3 11.1ZM29.1 29.69c-17.4-4.1-21.9-1.7-27.9 15.4-1-8.6 1.7-15.3 8.1-18.4 7.2-3.4 13.8-1.7 19.8 3Z",
        class: "svg-YO-logo_svg__cls-1"
      })
    ], -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "YO-logo"}) } }